/* eslint-disable max-lines-per-function */
import { useSuspenseQuery } from '@apollo/client/react';
import { useStandortContext } from '@/features/standortContext/StandortContext';
import {
  SummeNetto,
  Vertrag,
  VertragZahlungsmethode,
} from '@/domain/vertraege/shared/types/vertrag';
import { GET_VERTRAEGE_BY_STANDORTID } from '@/domain/vertraege/shared/hooks/graphql/queries';
import { GetVertraegeQuery, GetVertraegeQueryVariables } from '@/gql/graphql';
import { CURRENT_PREISMODELL } from '@/domain/vertraege/shared/hooks/preismodelle';

export function useVertraege(): {
  vertraege?: Vertrag[];
  error?: string;
} {
  const {
    currentStandort: { id: standortId },
  } = useStandortContext();
  const { data } = useSuspenseQuery<
    GetVertraegeQuery,
    GetVertraegeQueryVariables
  >(GET_VERTRAEGE_BY_STANDORTID, {
    variables: {
      standortId,
    },
    fetchPolicy: 'network-only',
  });

  if (data.vertraegeByIdStandort.length < 1) {
    return {
      vertraege: [],
    };
  }

  const result = data.vertraegeByIdStandort.filter(
    (vertragsdaten) => vertragsdaten !== null && vertragsdaten.id.length > 0,
  );

  const vertraege = result.map(
    (vertrag) =>
      new Vertrag({
        id: vertrag.id,
        kundennummer: vertrag.kundennummer,
        unternehmensname: vertrag.unternehmensname,
        aktiveAnzahl: vertrag.aktiveAnzahl,
        vereinbarteAnzahl: vertrag.vereinbarteAnzahl,
        vertragTarif: vertrag.vertragTarif,
        vertragIntervall: vertrag.vertragIntervall,
        faelligkeitsdatum: vertrag.faelligkeitsdatum || undefined,
        summeNetto: new SummeNetto({
          waehrung: vertrag.summeNetto.waehrung,
          wert: vertrag.summeNetto.wert,
        }),
        vertragZahlungsmethode:
          VertragZahlungsmethode[vertrag.vertragZahlungsmethode],
        preisModell: vertrag.preisModell,
        status: vertrag.vertragstatus,
      }),
  );

  const sortedVertraege = vertraege.sort((vertrag) => {
    if (vertrag.preisModell === CURRENT_PREISMODELL) {
      return 1;
    } else {
      return -1;
    }
  });

  return {
    vertraege: sortedVertraege,
  };
}
